import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
type Variant = 'amber' | 'outline' | 'ink' | 'outlineInk';
type ButtonLinkProps = {
  to: string;
  children: React.ReactNode;
  variant?: Variant;
  arrow?: boolean;
  className?: string;
};
const variants: Record<Variant, string> = {
  amber: 'bg-amber text-ink hover:bg-amber-deep',
  outline: 'border border-line text-paper hover:border-sand',
  ink: 'bg-ink text-paper hover:bg-stage',
  outlineInk: 'border border-ink/25 text-ink hover:border-ink'
};
export function ButtonLink({
  to,
  children,
  variant = 'amber',
  arrow = false,
  className = ''
}: ButtonLinkProps) {
  return <Link to={to} className={`group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 py-3.5 text-sm font-semibold transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber focus-visible:ring-offset-2 focus-visible:ring-offset-ink ${variants[variant]} ${className}`} data-id="element-232" data-mp="1it82drpbopmi">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-233" data-mp="2nncqnbu67x77" />}
    </Link>;
}